import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import { IAddressSuggestion } from '../../types/address';
import { ADDRESS_SUGGEST_URI, EAddressErrorMessages } from './constants';
import { IDaDataAddress, IDaDataSuggestionResponse } from '../../types/dadata';
import { fromDadataToAddress } from '../../mappers/address';
import { getAddressRequestBody, getRequestHeaders } from './utils';

export const getAddressSuggest = (query: string): TThunkAction<Promise<IAddressSuggestion[]>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, config, logger } = context;
    const defaultData: IAddressSuggestion[] = [];

    const token = config.get<string>('e2e.DadataApiKey');

    if (!token) {
      logger.error(EAddressErrorMessages.InvalidToken);

      return defaultData;
    }

    try {
      const response = await httpApi.httpRequest({
        method: 'POST',
        uri: ADDRESS_SUGGEST_URI,
        withCredentials: false,
        headers: getRequestHeaders({ token }),
        body: getAddressRequestBody({ query }),
      });

      if (response.responseStatusCode === 200) {
        const result = JSON.parse(response.responseBody) as IDaDataSuggestionResponse<IDaDataAddress>;

        return fromDadataToAddress(result.suggestions);
      }

      throw new HttpBadStatusCodeError(EAddressErrorMessages.InvalidResponse, response.responseStatusCode);
    } catch (e) {
      if (e instanceof HttpBadStatusCodeError) {
        logger.error(e.message);
      } else {
        logger.error(EAddressErrorMessages.ErrorRequest, e);
      }

      return defaultData;
    }
  };
};
